"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ActionsRedesignOpt;

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIOptConstants = require("ui-addon-opt/constants/UIOptConstants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _OptInsActions = require("crm_data/optIns/OptInsActions");

var _UIOpt = _interopRequireDefault(require("ui-addon-opt/components/UIOpt"));

function ActionsRedesignOpt(_ref) {
  var isUngatedForActionsRedesign = _ref.isUngatedForActionsRedesign,
      isOptedInToActionsRedesign = _ref.isOptedInToActionsRedesign;

  if (!isUngatedForActionsRedesign) {
    return null;
  }

  var optInText = _react.default.createElement(_FormattedMessage.default, {
    message: "profileTimeline.actionRedesignOpt.optText.optIn"
  });

  var optOutText = _react.default.createElement(_FormattedMessage.default, {
    message: "profileTimeline.actionRedesignOpt.optText.optOut"
  });

  function handleOptStateChanged(_ref2) {
    var value = _ref2.value;
    (0, _OptInsActions.updateOptinStatus)('record-actions-redesign', value);
  }

  return _react.default.createElement(_UIOpt.default, {
    optinName: "record-actions-redesign",
    optinView: isOptedInToActionsRedesign ? _UIOptConstants.OPTIN_VIEW_NEW : _UIOptConstants.OPTIN_VIEW_CURRENT,
    optInButtonText: optInText,
    optOutButtonText: optOutText,
    showIcon: !isOptedInToActionsRedesign,
    onOptStateChanged: handleOptStateChanged
  });
}

ActionsRedesignOpt.propTypes = {
  isUngatedForActionsRedesign: _propTypes.default.bool,
  isOptedInToActionsRedesign: _propTypes.default.bool
};
module.exports = exports.default;